export const DATA = "0x00";
export const CONFIRMATION_TIMEOUT = 30000; // 30sec

export enum ERROR_CODES {
  INSUFFICIENT_FUNDS_ERROR_MSG = "INSUFFICIENT_FUNDS",
  INSUFFICIENT_FUNDS_ERROR_CODE = -32603,
  INSUFFICIENT_FUNDS_METAPRO_ERROR_CODE = 3,
  SIGN_ERROR = 4001,
  TRANSACTION_STATUS_ERROR = "TRANSACTION_STATUS_ERROR",
  ACTION_REJECTED = "ACTION_REJECTED",
  MPRO_WALLET_ACTION_REJECTED_MSG = "Rejected by the user",
  // Node sales
  LVL_UNITS_EXCEEDED_MSG = "NODEsales: Purchased amount must be lower or equal to units in level",
  PROMO_UNITS_PER_WALLET_EXCEEDED_MSG = "NODEsales: Exceded max promo units per wallet",
  MAX_UNITS_EXCEEDED_MSG = "NODEsales: Purchased amount exceeds max units per wallet",
  MGA_MAX_UNITS_EXCEEDED_MSG = "MGASales: Purchased amount exceeds max units per wallet",
  PROMO_UNITS_EXCEEDED_MSG = "NODEsales: Exceded max promo units",
  PROMO_WALLET_NOT_ELIGIBLE_MSG = "NODEsales: Wallet not eligible to participate in this promo",
  MGA_PROMO_WALLET_NOT_ELIGIBLE_MSG = "MGASales: Wallet not eligible to participate in this promo",
  NOT_WHITELISTED = "Staker is not whitelisted",
  NOTHING_TO_CLAIM = "MPRODoubleRewardStake: No tokens to claim",
  /*
   * Stake reverts, taken from the deployed contracts rather than guessed.
   * Every one of these used to reach the user as "Something went wrong, try
   * again in a while" — advice that is wrong for all of them: waiting does
   * not help when the unstake window has not opened, and trying again does
   * not help when there is nothing to claim. On the page holding the most
   * unclaimed MPRO on the platform, that was the whole of our feedback.
   */
  UNSTAKE_NOT_STARTED = "MPROStake: Unstake period has not started",
  STAKE_PERIOD_ENDED = "Stake period has ended",
  NO_TOKENS_TO_CLAIM = "MPROStake: No tokens to claim",
  COMPOUND_DISABLED = "MPROStake: Compound is not enabled",
  NO_REWARDS_TO_COMPOUND = "MPROStake: No rewards to compound",
  CONTRACT_PAUSED = "Pausable: paused",
  /* Wallet and network, not the contract. */
  WALLETCONNECT_NO_CHAIN_SWITCH = "does not support programmatic chain switching",
  INSUFFICIENT_FUNDS_FOR_GAS = "insufficient funds for",
  /*
   * The app tried to send through a read-only provider. Reached a real user on
   * an iPhone as "Something went wrong": the wallet had not finished attaching
   * when the contract instance was built. Fixed at the source, and named here
   * so that if it ever recurs it says something true.
   */
  NO_SIGNER = "requires a signer",
  /*
   * WebKit says "Load failed" and Chrome "Failed to fetch" for the same thing:
   * the request never reached anyone. It is not a contract error and telling
   * somebody their transaction failed is wrong — nothing was sent.
   */
  NETWORK_UNREACHABLE_WEBKIT = "Load failed",
  NETWORK_UNREACHABLE = "Failed to fetch",
  /** The wallet extension itself would not connect. */
  WALLET_CONNECT_FAILED = "Failed to connect to",
  /*
   * The page believes a wallet is connected — the address is there, the
   * balances render — but the WalletConnect session behind it is gone, so
   * every request throws before it reaches anyone. A holder with 40,215 MPRO
   * waiting met this five times on 6 September, was told "the request never
   * reached the network", and wrote to us that we had blocked them. Nothing
   * was blocked and nothing was wrong with their stake; their session was
   * dead and the page never said so.
   */
  WALLET_SESSION_EXPIRED = "call connect() before request()",
}

export enum TransactionProgress {
  INITIAL = "initial",
  PENDING = "pending",
  CONFIRMING = "confirming",
  SUCCESS = "success",
  ERROR = "error",
  TRANSACTION_STATUS_ERROR = "transaction_status_error",
}
